import { useState } from 'react';
import classnames from 'classnames';
import Icon from './icon_close.svg';
import s from './index.module.scss';

const TYPES = {
  info: 'info',
  danger: 'danger',
  normal: 'normal',
  warning: 'warning',
  success: 'success',
  secondary: 'secondary',
};

export const Alert = ({
  type,
  icon,
  title,
  description,
  action,
  children,
  sessionId,
  className,
}) => {
  const [show, setShow] = useState(sessionId ? !sessionStorage.getItem(sessionId) : true);
  if (!show) return null;

  const onClose = () => {
    sessionStorage.setItem(sessionId, '1');
    setShow(false);
  };

  return (
    <div className={classnames(s.block, type, className)}>
      {icon}
      <div className={s.content}>
        {children || (
          <>
            <div className={s.title}>{title}</div>
            {description && <div className={s.desc}>{description}</div>}
            {action}
          </>
        )}
      </div>
      {sessionId && (
        <button type="button" className={s.btn_close} onClick={onClose}>
          <img src={Icon} alt="close" width={24} height={24} />
        </button>
      )}
    </div>
  );
};
